// import { AnalyticsService } from './services/tracker/analytics.service';
import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ModalConfig} from './components/modal/modal.config';
import {ModalComponent} from './components/modal/modal.component';

import {Event as NavigationEvent} from '@angular/router';
import {ApiService} from './services/api/api.service';
import {BreadcrumbsService} from './services/breadcrumbs/breadcrumbs.service';
import { ConfigService } from './services/config/config.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit ,OnInit{
  title = 'aifa-bds-esp-info-farm-fe';



  @ViewChild('modal') disclaimerModal!: ModalComponent

  @HostListener('window:popstate', ['$event'])
  onpopstate(event: NavigationEvent) {
    this.breadcrumbService.removeNavigationLevels(2)

   
  }

  ngOnInit(): void {
    this.loadMatomoScript();
  }
  // I initialize the app component.
  constructor(
    private api: ApiService,
    private breadcrumbService: BreadcrumbsService,
    private configService: ConfigService
    // private analyticsService:AnalyticsService
  ) {}








  disclaimerModalConfig: ModalConfig = {
    modalTitle: 'Condizioni di utilizzo',
    dismissButtonLabel: 'ACCETTA',
    hideCloseButton: () => true,
    hideCheckBox: () => false,
    disableDismissButton: () => true,
    onDismiss: this.disclaimerModalDismissHandler
  }

  ngAfterViewInit(): void {
    const preference = sessionStorage.getItem('hideDisclaimer');

    if (preference === null) {
      this.disclaimerModal.open()
    }
  }


  disclaimerModalDismissHandler(): boolean {
    sessionStorage.setItem('hideDisclaimer', 'true')
    return true
  }

  loadMatomoScript(): void {
    const head = document.head;
    const config = this.configService.getConfig()
    
    const script = document.createElement("script");
    script.type = "text/javascript";
    
    
    script.text = "var _paq = _paq || [];" +
    "_paq.push([\"setCookieDomain\", \"*.aifa.gov.it\"]);" +
    "_paq.push(['trackPageView']);" +
    "_paq.push(['enableLinkTracking']);" +
    "(function () {" +
    "  var u = \""+ config.ANALYTICS.trackerUrl +"\";" +
    "  _paq.push(['setTrackerUrl', u]);" +
    "  _paq.push(['setSiteId', '"+ config.ANALYTICS.siteId +"']);" +
    "  var secondaryTrackerUrl = '"+ config.ANALYTICS_AGID.trackerUrl +"';" +
    "  var secondaryWebsiteId = '"+ config.ANALYTICS_AGID.siteId +"';" +
    "  _paq.push(['addTracker', secondaryTrackerUrl, secondaryWebsiteId]);" +
    "  var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];" +
    "  g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = '"+ config.ANALYTICS.scriptUrl +"'; s.parentNode.insertBefore(g, s);" +
    "})();"
    

    head.appendChild(script);
    
  }
}
